import { useQuery } from "@apollo/client";
import { message } from "antd";

import { getJourneysVersions } from "Services/marketing-api/journeys/queries";
import { JourneyVersion } from "Types/Journey";

export type JourneyVersionsQueryResponse = {
    getJourneysVersions: {
        items: JourneyVersion[];
    };
};

export const useGetJourneyVersions = (id: string) => {
    const { loading, data, error } = useQuery<JourneyVersionsQueryResponse>(getJourneysVersions, {
        fetchPolicy: "cache-and-network",
        variables: { id },
        onError: (err) => {
            // eslint-disable-next-line no-console
            console.error("Failed to fetch journey versions:", err);
            message.error("Failed to load journey versions. Please try again.");
        },
    });

    // Backend already sorts by version descending, so no need to sort again client-side
    const versionsData: JourneyVersion[] = data?.getJourneysVersions?.items ?? [];

    return {
        loading,
        data: versionsData,
        error,
    };
};
